
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 1C5.65 1 .5 5.06.5 10.068c0 3.237 2.152 6.078 5.39 7.682-.176.608-1.132 3.909-1.17 4.168 0 0-.022.195.104.269.126.074.274.016.274.016.362-.05 4.196-2.743 4.86-3.21a14.71 14.71 0 002.042.143c6.352 0 11.5-4.061 11.5-9.068C23.5 5.06 18.352 1 12 1z","fill":"#3C1E1E"}}),_c('path',{attrs:{"d":"M20.17 13.074a.66.66 0 01-.928-.13l-1.556-2.062-.23.231v1.447a.664.664 0 01-1.327 0V8.023a.664.664 0 011.327 0v1.425l1.85-1.85a.516.516 0 01.368-.148c.166 0 .333.071.457.195a.653.653 0 01.195.42c.01.158-.042.3-.147.405l-1.51 1.511 1.632 2.164a.662.662 0 01-.13.929zM15.234 13.136h-2.128c-.35 0-.636-.273-.636-.608V8.023c0-.366.304-.664.677-.664.374 0 .678.298.678.664v3.896h1.41c.35 0 .636.274.636.609 0 .335-.286.608-.637.608zM11.881 13.133c-.132.06-.276.092-.421.092-.277 0-.49-.113-.553-.294l-.328-.86H8.556l-.329.861c-.063.18-.275.293-.552.293-.145 0-.29-.031-.422-.092-.182-.085-.358-.317-.157-.943l1.587-4.177c.112-.317.452-.645.884-.654.433.01.773.337.884.655l1.587 4.176c.203.626.026.86-.157.943zM6.306 12.6c0 .348-.298.633-.665.633-.365 0-.663-.285-.663-.633V8.658H3.943a.65.65 0 110-1.3h3.398c.359 0 .651.292.651.65 0 .358-.292.65-.651.65H6.306V12.6z","fill":"#FBE106"}}),_c('path',{attrs:{"fill":"#3C1E1E","d":"M8.905 10.896h1.325l-.663-1.882z"}})])
          )
        }
      }
    